<template>
  <v-select
    :value="value"
    :items="innerItems" 
    chips
    outlined
    dense
    deletable-chips
    multiple
    hide-details
    class="ml-3"
    @input="updateValue"
  >
  <template v-slot:prepend-item>
    <v-text-field 
      v-model="searchTerm"
      placeholder="Search"
      @input="searchItems"
      hide-details
      dense
      clearable
      flat
      solo
      solo-filled
      prepend-inner-icon="mdi-magnify"
    >
    </v-text-field>
  </template>
  <template v-slot:selection="{ item, index }">
    <v-chip
    close
    small
    color="blue"
    dark
    clear
    light
    @click:close="removeSelectedItems(item)"
    >
      <span class="font-weight-bold">{{ item }}</span>
    </v-chip>
  </template>
  </v-select>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    searchTerm: '',
    copiedItems: [],
    selectedItems: [],
    innerData: []
  }),
  methods: {
    removeSelectedItems (value) {
      this.$emit('input', this.value.filter(item => value !== item));
    },
    searchItems() {
      if (!this.searchTerm) {
        this.innerData = [...this.copiedItems]
      }

      this.innerData = this.copiedItems.filter((item) => {
        return item.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      });
    },
    updateValue(newValue) {
      this.$emit('input', newValue);
    }
  },
  computed: {
    innerItems () {
      return this.innerData
    }
  },
  watch: {
    items (value) {
      if (value) {
        this.innerData = [...this.items]
        this.copiedItems = [...this.items]
      }
    }
  }
}
</script>